<h3 class="header-upload pb-0" mat-dialog-title>
    {{data.user.UserName}}
    <button class="mt-4 mr-2 float-right close-btn" mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</h3>
<mat-dialog-content>
    <div class="mb-3 flex justify-content-between">
        <span class="sub-header">{{data.user.RoleName}} | {{data.user.StoreName}}</span>
    </div>
    <div class="flex">
        <div>
            <div class="mb-3">
                <p class="employee-value">{{data.user.FirstName}}</p>
                <p class="employee-label">First Name</p>
            </div>
            <div class="mb-3">
                <p class="employee-value">{{data.user.LastName}}</p>
                <p class="employee-label">Last Name</p>
            </div>
            <div class="mb-3">
                <p class="employee-value">{{data.user.Email}}</p>
                <p class="employee-label">Email</p>
            </div>
        </div>
    </div>
    <div class="flex">
        <div>
            <div class="mb-3">
                <p class="employee-value">{{data.user.RoleName}}</p>
                <p class="employee-label">Role</p>
                <span class="info-text">Having trouble? <a target="_blank" class="cursor-pointer" (click)="getRolePermissions()">See Role permission</a></span>
            </div>
            <div>
                <p class="employee-value">{{data.user.StoreName}}</p>
                <p class="employee-label">Assigned In</p>
            </div>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions class="pr-3 pb-3" align="end">
    <button class="delete-btn" mat-button (click)="deleteMerchantUser(data.user.UserId)" >Remove Employee</button>
    <button class="edit-btn" mat-button mat-dialog-close (click)="editEmployee()">Edit</button>
</mat-dialog-actions>